import { HubWithDetails } from ".";
import { executeServiceCall } from "./requests";

export const hubService = {
  async getPropertyRegisteredHubsForShellCommandsUsingApiToken(
    propertyID: string,
    token: string
  ): Promise<Array<HubWithDetails>> {
    return executeServiceCall(
      "./services/FormidableDesigns.Services.V1.HubService.GetPropertyRegisteredHubsForShellCommandsUsingApiToken",
      JSON.stringify({
        propertyID
      }),
      token
    );
  },
  async sendShellCommandToHubUsingApiToken(
    hubID: string,
    command: string,
    token: string
  ): Promise<string> {
    return executeServiceCall(
      "./services/FormidableDesigns.Services.V1.HubService.SendShellCommandToHubUsingApiToken",
      JSON.stringify({
        hubID,
        command
      }),
      token
    );
  }
};

